"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.consoleLogger = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
const _1 = require(".");
function consoleLogger(name, options) {
    const logger = {
        startTimer() {
            const start = new Date();
            return {
                logger: this,
                done: (args) => {
                    var _a, _b;
                    const duration = new Date().getTime() - start.getTime();
                    logger[(_a = args === null || args === void 0 ? void 0 : args.level) !== null && _a !== void 0 ? _a : _1.LogLevel.Info](`${(_b = args === null || args === void 0 ? void 0 : args.message) !== null && _b !== void 0 ? _b : 'Timer'} completed in: ${duration}`);
                    return true;
                },
            };
        },
        child(metadata, name) {
            return consoleLogger(name, { metadata });
        },
        log: (level, message, metadata) => {
            return logger[level](message, message);
        },
        debug: (...args) => {
            console.debug(...args);
            return logger;
        },
        info: (...args) => {
            console.log(...args);
            return logger;
        },
        warn: (...args) => {
            console.warn(...args);
            return logger;
        },
        error: (...args) => {
            console.error(...args);
            return logger;
        },
    };
    return logger;
}
exports.consoleLogger = consoleLogger;
//# sourceMappingURL=utils.js.map